import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexChart,
  ApexFill,
  ChartComponent,
  NgApexchartsModule,
  ApexStroke,
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
};
@Component({
    selector: 'app-gauge',
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgApexchartsModule],
    templateUrl: './gauge.component.html',
    styleUrl: './gauge.component.css'
})

export class GaugeComponent {
  @Input() gaugeResponse: any[] = [];
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  chartOptions: ChartOptions = {
    series: [76],
    chart: {
      type: "radialBar",
      offsetY: -20,
      width: 150,
      height: 150
    },
    stroke: {
      lineCap: "round"   // <--- move here, not inside radialBar
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          size: '60%' // Adjust for arc thickness
        },
        track: {
          background: "#e7e7e7",
          strokeWidth: "80%",
          margin: 5,
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            opacity: 0.31,
            blur: 2
          }
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: -2,
            fontSize: "22px"
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91]
      }
    },
    labels: ["Average Results"]
  };

  getChartOptions(item: any): ChartOptions {
    return {
      series: [20],
      chart: {
        type: "radialBar",
        offsetY: -20,
        width: 150,
        height: 150
      },
      stroke: {
        lineCap: "round"
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            size: '60%'
          },
          track: {
            background: ['009CFF'],
            strokeWidth: "80%",
            margin: 5,
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              opacity: 0.31,
              blur: 2
            }
          },
          dataLabels: {
            name: { show: false },
            value: {
              offsetY: -2,
              fontSize: "13px",
              fontWeight: "500"
            }
          }
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          shadeIntensity: 0.4,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 53, 91]
        }
      },
      labels: [item.text]
    };
  }

}
